export default __webpack_public_path__ + "static/media/img3.4551e0ca.jpg";